import React, { useEffect, Fragment, useContext } from 'react';
import { getToken } from './tokenHelper';
import {
  checkTokenRequest,
  loadUserRequest,
  loadPermissionsRequest,
  removePermissions,
} from '../reducers/Auth/actions';
import { useInterval } from '../hooks';

const Authentication = props => {
  const { context } = props;
  const store = useContext(context);
  const state = store.getState();
  const { user } = state.auth;
  const { settings } = state;
  const { authorizationApi, ssoUrl, ssoRedirectUrl } = settings;

  useInterval(() => {
    if (getToken() && localStorage.getItem('OSS_Token_EXPIRES_ON') - new Date().getTime() < 0) {
      store.dispatch(checkTokenRequest({ settings, token: getToken() }));
    }
  }, 5000);

  useEffect(() => {
    if (!user && getToken()) {
      store.dispatch(removePermissions());
      store.dispatch(store.dispatch(loadPermissionsRequest({ url: authorizationApi })));
    }

    if (user && localStorage.getItem('OSS_Must_Login_Oss')) {
      localStorage.removeItem('OSS_Must_Login_Oss');

      if (ssoUrl) {
        const redirectUrl = ssoRedirectUrl || `${window.location.origin}/close-window`;
        window.open(`${ssoUrl}/sso-handler?token=${getToken()}&redirectUri=${redirectUrl}`);

        window.focus();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, removePermissions, loadUserRequest, authorizationApi, ssoUrl, ssoRedirectUrl]);

  return <Fragment />;
};

export default Authentication;
